import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {abroadCountriesSearched, setSearchCountryResults, setCurrentCountryDataToShow} from '../../cellcomAbroadBlockSlice';
import {connect} from 'react-redux';
import images from '../images/images';
import './SelectAndSearch.scss';

function SelectAndSearch({
  countries,
  onChange,
  placeholder,
  abroadCountriesSearched,
  setCurrentCountryDataToShow,
  EmptySearchResult,
  setExpendedImportantInfo,
}) {
  const [selectedValue, setSelectedValue] = useState('');
  const [open, setOpen] = useState(false);
  const [hasCountries, setHasCountries] = useState(false);
  const hasTxt = selectedValue.length > 0;

  const displayedText = selectedValue || placeholder;
  useEffect(() => {
    if (countries && countries.length > 0) {
      setHasCountries(true);
    } else {
      setHasCountries(false);
    }
  }, [countries]);

  function updateValue(val) {
    setSelectedValue(val);
    setCurrentCountryDataToShow(val);
    setOpen(false);
  }

  function searchCountry(val) {
    setSelectedValue(val);
    setCurrentCountryDataToShow('');
    if (val.trim() && val) {
      abroadCountriesSearched(val);
      setOpen(true);
    } else {
      setOpen(false);
      setHasCountries(false);
    }
  }

  const searchResultString = (country) => {
    if (country.searchedCity?.trim()) {
      return `${country.searchedCity} (<bdi>${country.countryHebName}</bdi>)`;
    } else return `<bdi>${country.countryHebName}</bdi>`;
  };

  function renderDropDown() {
    if (open && hasCountries) {
      return (
        <div className={'select-search-dropdown'}>
          {countries.map((country) => (
            <div
              key={country.countryCode}
              value={country.countryHebName}
              className={'select-search-option'}
              title={country.countryHebName}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                updateValue(country.countryHebName);
              }}
              dangerouslySetInnerHTML={{__html: searchResultString(country)}}></div>
          ))}
        </div>
      );
    } else if (open && !hasCountries) {
      return EmptySearchResult(selectedValue);
    }
    return null;
  }

  function resetX() {
    setSelectedValue('');
    setCurrentCountryDataToShow('');
    setExpendedImportantInfo(false);
    setOpen(false);
  }

  return (
    <>
      <div className={'select-search-wrapper'}>
        <input
          className={`search-input${hasTxt ? ' grey' : ''}`}
          value={selectedValue}
          placeholder={displayedText}
          type='text'
          onChange={(e) => searchCountry(e.target.value)}></input>
        <div className='icon'>
          {selectedValue && selectedValue.length > 0 ? (
            <Image className='magnify-x' src={images.xIcon} alt='magnify' onClick={() => resetX()} />
          ) : (
            <Image src={images.magnify} alt='magnify' />
          )}
        </div>
      </div>
      {renderDropDown()}
    </>
  );
}

const mapStateToProps = (state) => ({
  countries: state.cellcomAbroad.searchCountryResults,
});

const mapDispatchToProps = {
  abroadCountriesSearched,
  setSearchCountryResults,
  setCurrentCountryDataToShow,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectAndSearch);
